<script>
    export default {

        props: {
            store: {
                required: true,
            },
        },

        data() {
            return {
                captureRevenueRegex: /([0-9])+(.+)/,
            }
        },

        render() {
            return this.$scopedSlots.default({
                hasElevatedCashback: this.hasElevatedCashback,
                defaultCashback: this.defaultCashback,
                currentCashback: this.currentCashback,
                upToText: this.upToText,
            });
        },

        computed: {
            upToText() {
                return this.removeRevenueValue(this.store.revenue_text);
            },
            currentCashback() {
                if(this.doubleSplit) {
                    return this.store.double_split_revenue_text;
                }

                return this.store.revenue_text_short;
            },
            defaultCashback() {
                if(this.hasElevatedCashback) {
                    let revenueText;

                    if(this.doubleSplit) {
                        revenueText = this.store.revenue_text_short;
                    } else {
                        revenueText = this.nextLowerRevenuePeriod[0].revenue_text;
                    }

                    return revenueText.match(this.captureRevenueRegex)[0];
                }
            },
            nextLowerRevenuePeriod() {
                if(!this.store.next_revenue_values) {
                    return [];
                }

                return this.store.next_revenue_values.sort((a, b) => new Date(b.start).getTime() - new Date(a.start).getTime())
                    .filter(revenue => {
                    return parseFloat(revenue.value) < parseFloat(this.store.revenue_value);
                })
            },
            doubleSplit() {
                if(this.store.double_split.length == 0) {
                    return false;
                }

                return true;
            },
            hasElevatedCashback() {
                return this.nextLowerRevenuePeriod.length > 0 || this.doubleSplit;
            }
        },

        methods: {
            removeRevenueValue(revenueText) {
                if(!revenueText) {
                    return revenueText;
                }

                return revenueText.replace(this.captureRevenueRegex, '');
            },
        }
    }
</script>
